import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import i18n from './i18n';
import '../styles-v2/PartnerLogos.css';
import { useTranslation } from 'react-i18next';

import sinomalogo from "../Image/out-foulder-img/sinoma-logo.png";
import transenerlogo from "../Image/out-foulder-img/transener-logo.png";
import trasbalogo from "../Image/out-foulder-img/transba-logo.png";
import cementologo from "../Image/out-foulder-img/cemento.png";
import metalurgicamitre from "../Image/out-foulder-img/metalurgica-mitre.png";
import capitanich from "../Image/out-foulder-img/capitanich-logo.png";
import finningcat from "../Image/out-foulder-img/finningcat-logo.jpg";
import minerar from "../Image/out-foulder-img/minerar.jpeg";
import canterapiatti from "../Image/out-foulder-img/cantera-piatti.png";
import aventresarg from "../Image/out-foulder-img/aventresarg.jpg";
import superglass from "../Image/out-foulder-img/superglass.png";
import cerronegro from "../Image/out-foulder-img/cerronegro.png";
import eq from "../Image/out-foulder-img/eq.jpg";
import cooperativaelectrica from "../Image/out-foulder-img/cooperativaelectrica.jpg";
import ferrosurroca from "../Image/out-foulder-img/ferrosurroca.jpg";
import mateo from "../Image/out-foulder-img/mateo.jpg";

const logos = [
    { id: 1, name: 'sinoma', src: sinomalogo },
    { id: 2, name: 'transener', src: transenerlogo },
    { id: 3, name: 'canterapiatti', src: finningcat },
    { id: 4, name: 'trasba', src: trasbalogo },
    { id: 5, name: 'cemento av', src: cementologo },
    { id: 6, name: 'mitre', src: metalurgicamitre },
    { id: 7, name: 'capitanich', src: capitanich },
    { id: 8, name: 'minerar', src: minerar },
    { id: 9, name: 'canterapiatti', src: canterapiatti },
    { id: 10, name: 'aventresarg', src: aventresarg },
    { id: 16, name: 'superglass', src: superglass },
    { id: 11, name: 'cerronegro', src: cerronegro },
    { id: 12, name: 'eq', src: eq },
    { id: 13, name: 'cooperativaelectrica', src: cooperativaelectrica },
    { id: 14, name: 'ferrosurroca', src: ferrosurroca },
    { id: 15, name: 'mateo', src: mateo },
];

const PartnerLogos = () => {
    return (
        <div className="logos-slider">
            <div className="logos-slide">
                {logos.map(logo => (
                    <img key={logo.id} src={logo.src} alt={logo.name} />
                ))}
                {logos.map(logo => (
                    <img key={`copy-${logo.id}`} src={logo.src} alt={logo.name} />
                ))}
            </div>
        </div>
    );
};

const Empresas = () => {
    const { t } = useTranslation();
    const { lang } = useParams(); // Obtenemos el idioma de la URL

    // 3. Sincronización con la URL
    useEffect(() => {
        if (lang && i18n.language !== lang) {
            i18n.changeLanguage(lang).catch(err => console.error(err));
        }
    }, [lang]);

    const empresasRef = useRef(null);
    const [isEmpresasVisible, setIsEmpresasVisible] = useState(false);

    useEffect(() => {
        const elementoActual = empresasRef.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsEmpresasVisible(true);
                }
            },
            { threshold: 0.3 }
        );

        if (elementoActual) observer.observe(elementoActual);

        return () => {
            if (elementoActual) observer.unobserve(elementoActual);
        };
    }, []);

    return (
        <section
            id="empresas"
            className={`section empresas fade-in-section ${isEmpresasVisible ? 'is-visible' : ''}`}
            ref={empresasRef}
        >
            <div className="empresas-description-container">
                <h2>{t('partners.title')}</h2>
                <p className="nuestros-cliente-p">
                    {t('partners.description')}
                </p>
            </div>
            <PartnerLogos/>
        </section>
    );
};

export default Empresas;